import React, { useEffect, useState } from 'react';
import ProductosLinea from './ProductosLinea';
import { getRelatedProducts } from '../services/catalogApi';

// Muestra el mismo carrusel que ProductosLinea (encabezado, flechas,
// variantes, badge de descuento, etc.), pero con productos elegidos por su
// relación semántica con el producto abierto (categorías y tags
// compartidos, misma línea) en vez de un filtro fijo de línea/categoría.
const ProductosRelacionados = ({ productoId }) => {
  const [relacionados, setRelacionados] = useState(null); // null = cargando

  useEffect(() => {
    let vigente = true;

    getRelatedProducts({ articuloActual: productoId })
      .then((productos) => {
        if (vigente) setRelacionados(productos);
      })
      .catch(() => {
        if (vigente) setRelacionados([]);
      });

    return () => {
      vigente = false;
    };
  }, [productoId]);

  if (relacionados === null) return null;

  return (
    <ProductosLinea
      nombre="También te puede interesar"
      kicker="Relacionado con este producto"
      productos={relacionados}
    />
  );
};

export default ProductosRelacionados;
